import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { Form as FormProvider } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { ROUTES } from 'routes'
import { Form } from './Form'
import { Schema, schema, schemaDefault } from './schema'
import { useUpdateAdUnitViewabilityTools } from './useUpdateAdUnitViewabilityTools'

export const FormContainer = (): React.JSX.Element => {
  const { adUnit, formId, loading, setTouched, setValid } = useContext(AddEditAdUnitContext)
  const { errors: apiErrors, update } = useUpdateAdUnitViewabilityTools()

  if (!adUnit) {
    return <Loading />
  } else if (adUnit.outOfPage) {
    return <Navigate to={ROUTES.BASE.NOT_FOUND} />
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault({
        adUnitViewabilityTools: adUnit.adUnitViewabilityTool,
        domainLazyLoadType: adUnit.domain.domainViewabilityTools.lazyLoadType,
      })}
    >
      {() => <Form />}
    </FormProvider>
  )
}
